import React, { useEffect, useLayoutEffect, useState } from 'react'
import styled from 'styled-components'
import qs from 'qs'
import CMS from '@talus-analytics/library.airtable-cms'

import { ContentContainer, Main, Nav, Footer, Layout } from 'components/layout'

import FilterBar from './FilterBar/FilterBar'
import ActiveFilters from './FilterBar/ActiveFilters'
import useExplorePageData from 'cmsHooks/useExplorePageData'
import ImageHeader from 'components/ui/ImageHeader'
import { ExploreState } from '../types'

const Header = styled.header`
  text-align: center;
`

interface ExploreWithFiltersProps {
  exploreState: ExploreState
  setExploreState: React.Dispatch<React.SetStateAction<ExploreState>>
  children: JSX.Element | JSX.Element[]
}
const ExploreWithFilters = ({
  exploreState,
  setExploreState,
  children,
}: ExploreWithFiltersProps): JSX.Element => {
  const explorePageContent = useExplorePageData()

  //TODO: make these custom hook and call from index pages of Table and Columns
  // right next to where state is declared

  useLayoutEffect(() => {
    setExploreState(qs.parse(window.location.search.split('?')[1]))
  }, [])

  // store explore state in the query string whenever it chagnges
  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      Object.keys(exploreState).length > 0 &&
      window.location.search.split('?')[1] !== qs.stringify(exploreState)
    ) {
      const newURL =
        window.location.origin +
        window.location.pathname +
        '?' +
        qs.stringify(exploreState)

      window.history.replaceState({}, '', newURL)
    }
  }, [exploreState])

  console.log(exploreState)
  // resources.map(group =>
  //   group.nodes.sort(node => node.data.Authoring_organization)
  // )
  return (
    <Layout>
      {/* TODO: get SEO title from Airtable */}
      <CMS.SEO title={'Explore'} />
      <Nav />
      <ImageHeader cmsData={explorePageContent} />
      <Main>
        <ContentContainer>
          <Header>
            <h1>
              <CMS.Text name={'First header'} data={explorePageContent} />
            </h1>
          </Header>
          <FilterBar
            {...{
              exploreState,
              setExploreState,
            }}
          />
          <ActiveFilters {...{ exploreState, setExploreState }} />
          {children}
        </ContentContainer>
      </Main>
      <Footer />
    </Layout>
  )
}

export default ExploreWithFilters
